var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          staticClass: "wkb-expand-progress-overlay",
          attrs: {
            role: "alertdialog",
            "aria-modal": "true",
            "aria-live": "assertive",
            "aria-busy": "true",
            "aria-label": _vm.message || "Expanding graph",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "wkb-expand-progress-card",
              class: { "has-batches": _vm.hasBatches },
            },
            [
              _c("span", {
                staticClass: "wkb-expand-progress-spinner",
                attrs: { "aria-hidden": "true" },
              }),
              _c("p", { staticClass: "wkb-expand-progress-message" }, [
                _vm._v(_vm._s(_vm.message || "Expanding graph…")),
              ]),
              _vm.hasBatches
                ? _c(
                    "details",
                    {
                      staticClass: "wkb-expand-progress-batches",
                      attrs: { open: "" },
                    },
                    [
                      _c(
                        "summary",
                        { staticClass: "wkb-expand-progress-batches-summary" },
                        [_vm._v(" Neighbor classification batches ")]
                      ),
                      _c(
                        "div",
                        { staticClass: "wkb-expand-progress-batches-body" },
                        [
                          _c("WorkspaceExpandBatchesContent", {
                            attrs: {
                              progress: _vm.progress,
                              variant: "overlay",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  )
                : _vm._e(),
              _c("p", { staticClass: "wkb-expand-progress-note" }, [
                _vm._v("Graph changes are paused while expansion runs."),
              ]),
            ]
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }